// API related actions
export const FETCHING_SYSTEM_PARAMETER = '@@toyota/FETCHING_SYSTEM_PARAMETER';
export const FETCHED_SYSTEM_PARAMETER = '@@toyota/FETCHED_SYSTEM_PARAMETER';
export const FETCHED_SYSTEM_PARAMETER_FAILED = '@@toyota/FETCHED_SYSTEM_PARAMETER_FAILED';
export const FETCHING_SYSTEM_PARAMETERS = '@@toyota/FETCHING_SYSTEM_PARAMETERS';
export const FETCHED_SYSTEM_PARAMETERS = '@@toyota/FETCHED_SYSTEM_PARAMETERS';
export const FETCHED_SYSTEM_PARAMETERS_FAILED = '@@toyota/FETCHED_SYSTEM_PARAMETERS_FAILED';
export const UPDATING_SYSTEM_PARAMETER = '@@toyota/UPDATING_SYSTEM_PARAMETER';
export const UPDATED_SYSTEM_PARAMETER = '@@toyota/UPDATED_SYSTEM_PARAMETER';
export const UPDATED_SYSTEM_PARAMETER_FAILED = '@@toyota/UPDATED_SYSTEM_PARAMETER_FAILED';
export const CREATING_SYSTEM_PARAMETER = '@@toyota/CREATING_SYSTEM_PARAMETER';
export const CREATED_SYSTEM_PARAMETER = '@@toyota/CREATED_SYSTEM_PARAMETER';
export const CREATED_SYSTEM_PARAMETER_FAILED = '@@toyota/CREATED_SYSTEM_PARAMETER_FAILED';
// No related api actions
export const DELETE_SYSTEM_PARAMETERS_DATA = '@@toyota/DELETE_SYSTEM_PARAMETERS_DATA';
